import ziggyRoute from "ziggy-js";

export default function route(name, params, absolute, customZiggy) {
    const router = ziggyRoute(name, params, absolute, customZiggy);

    return name ? router.toString() : router;
}